import Swiper from 'swiper';
import { Navigation, EffectFade, Thumbs } from 'swiper/modules';

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/a11y'
import 'swiper/css/effect-fade'
import 'swiper/css/thumbs'

import './FinishOptions.css'

export default () => {

  if(document.querySelector('[data-fo-tabs]')) {
    const tabsSlideEl = document?.querySelectorAll('[data-tab-slide-index]');
    let sliderContent, sliderTabs;

    const swiperParamsTabs = {
      // Install modules
      modules: [Navigation, EffectFade, Thumbs],
      slidesPerView: 'auto',
      spaceBetween: 37,
      cssMode: true,
      navigation: {
        prevEl: '.slider-finish-options__nav-tabs-prev',
        nextEl: '.slider-finish-options__nav-tabs-next',
      },
    };

    sliderTabs = new Swiper('[data-fo-tabs]', swiperParamsTabs);

    if(document.querySelector('[data-fo-content]')) {
      const swiperParamsContent = {
        // Install modules
        modules: [Navigation, EffectFade, Thumbs],
        slidesPerView: 1,
        navigation: {
          prevEl: '.slider-finish-options__nav-content-prev',
          nextEl: '.slider-finish-options__nav-content-next',
        },
        thumbs: {
          swiper: sliderTabs,
        },
        nested: true,
        touchRatio: 0,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
      };
    
      sliderContent = new Swiper('[data-fo-content]', swiperParamsContent);
    }

  }

}